import request from 'admin-ng/util/request-promise';
import {BASEMAPS} from '.';

export const basemapsByName = fragment =>
  request(`${BASEMAPS}?name__contains=${fragment}`, 'get');
